import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nrTreeSelectSelectedItems',
})
export class NrTreeSelectSelectedItemsPipe implements PipeTransform {
  transform(value: Array<{ label?: string; children?: unknown }>, maxCount: number): string {
    const selectedChildrens = value.filter((node) => !('children' in node));
    const length = selectedChildrens.length;
    return length < maxCount
      ? selectedChildrens
          .map((node) => node.label)
          .toString()
          .replaceAll(',', ', ')
      : `${length} items selected`;
  }
}
